var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAnchor = function SvgIconAnchor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 7.571a2.876 2.876 0 1 0-2 0V9.5H8.25a1 1 0 0 0 0 2H11v6.377A4.75 4.75 0 0 0 8.25 17a3.5 3.5 0 0 1-3.5-3.5 1 1 0 1 0-2 0 5.5 5.5 0 0 0 5.5 5.5A2.75 2.75 0 0 1 11 21.75a1 1 0 1 0 2 0A2.75 2.75 0 0 1 15.75 19a5.5 5.5 0 0 0 5.5-5.5 1 1 0 1 0-2 0 3.5 3.5 0 0 1-3.5 3.5 4.75 4.75 0 0 0-2.75.877V11.5h2.75a1 1 0 1 0 0-2H13zm-1.875-2.696a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconAnchor;